module.exports = __webpack_public_path__ + "static/media/bookshelf.4fa5b0bf.png";